import { getRoundTwo } from "./decimal";




//*compara los datos state con localstorage , con el fin de 
//* tener los datos sincronizado el localstorage con el state
export const compareArrayStateStoragePolizaPagar = (state) => {

    const datosLocalstorage = JSON.parse(localStorage.getItem('pagar')) || [];

    let arrayPagar = [];
    for (let i = 0; i < state.length; i++) {

        for (let j = 0; j < datosLocalstorage.length; j++) {
            if (
                state[i]['ID'] == datosLocalstorage[j]['ID'] &&
                state[i]['IDTIPOPAGO'] == datosLocalstorage[j]['IDTIPOPAGO'] &&
                state[i]['NUMERO'] == datosLocalstorage[j]['NUMERO']
            ) {

                // objeto
                let object = {
                    ID: datosLocalstorage[j]['ID'] || 0,
                    PAGAR: datosLocalstorage[j]['PAGAR'] || 0,
                    CHECK: true
                }

                // array
                arrayPagar.push(object);
            }
        }
    }

    // todos los datos devuelto sobreentiende que tiene el CHECK:TRUE
    return arrayPagar;
}

//* obtiene el total a pagar 
export const getTotalPagar = (statePago) => {


    // comparar datos de state y el localstorage 
    let arrayPagar = compareArrayStateStoragePolizaPagar(statePago);

    // calcular totalizado
    let totalizado = 0;
    totalizado = arrayPagar.reduce((acumulador, value) => acumulador += getRoundTwo(value.PAGAR), 0);

    return getRoundTwo(totalizado);
}


// * unificar state con el historial(storage validado) de pago 
//* se recomienda utilizar compareArrayStateStoragePolizaPagar para tener storage validado y de sincronizado al state
export const unificarArrayStateStoragePolizaPagar = (dataDB, validStorage) => {

    let arrayUnificado = [];
    for (let i = 0; i < dataDB.length; i++) {

        let object = {};
        object = Object.assign(object, dataDB[i]);

        for (let j = 0; j < validStorage.length; j++) {
            if (dataDB[i]['ID'] == validStorage[j]['ID']) {
                object = { ...object, ...validStorage[j] }
            }
        }
        arrayUnificado.push(object);
    }

    return arrayUnificado;
}

export const filterByParams = (data, filters) => {
    return data.filter(item => {
        return Object.keys(filters).every(key => {
            if (typeof filters[key] === 'function') {
                return filters[key](item[key]);
            }
            return item[key] === filters[key];
        });
    });
}
